import axiosClient from './axiosClient';

export const saveDraft = (payload) => axiosClient.post('/drafts', payload).then((r) => r.data?.data);
export const listDrafts = (poCode) => axiosClient.get('/drafts', { params: { poCode } }).then((r) => r.data?.data ?? []);
export const getDraft = (guid) => axiosClient.get(`/drafts/${guid}`).then((r) => r.data?.data);
export const deleteDraft = (guid) => axiosClient.delete(`/drafts/${guid}`).then((r) => r.data);
